import { render, staticRenderFns } from "./UsersTable.vue?vue&type=template&id=4e0966ac&scoped=true&"
import script from "./UsersTable.vue?vue&type=script&lang=js&"
export * from "./UsersTable.vue?vue&type=script&lang=js&"
import style0 from "./UsersTable.vue?vue&type=style&index=0&id=4e0966ac&lang=scss&scoped=true&"
import style1 from "./UsersTable.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0966ac",
  null
  
)

export default component.exports